import Link from "next/link";

const FOOTER_LINKS = [
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Refund Policy", href: "/refund-policy" },
  { label: "Terms & Conditions", href: "/terms-conditions" },
];

const BottomLinks = () => (
  <>
    <hr className="h-px my-3 bg-gray-300 border-0 dark:bg-gray-700" />
    <div className="mt-6 flex flex-col md:flex-row md:justify-between items-center gap-4">
      <p className="text-ink-secondary text-sm">
        © {new Date().getFullYear()} Travela. All rights reserved.
      </p>
      <div className="flex gap-4">
        {FOOTER_LINKS.map((item) => (
          <Link
            key={item.href}
            href={item.href}
            aria-label={item.label}
            className="text-ink-secondary hover:text-ink-black underline text-sm"
          >
            {item.label}
          </Link>
        ))}
      </div>
    </div>
  </>
);

export default BottomLinks;
